import React, { useRef, useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import { Panel as Wrapper } from "@kido/ui";
import daggy from "daggy";
import { useAsyncEffect } from "@kido/hooks";
import {
  appThemeSelector,
  filtersSelector,
  reportIDSelector
} from "../../store/selectors";
import Filters from "../Filters";
import PDF from "../PDF";
import Map from "../Map";
import Loading from "../Loading";
import Failure from "../Failure";
import {
  getMainMetrics,
  getUniqueVisitors,
  getUniqueVisitorsOvernight,
  getRanks,
  finalizeReport
} from "../../data/request";

const UI = daggy.taggedSum("UI", {
  Success: [[]],
  Failure: [],
  Loading: [[]],
  Empty: []
});

const Panel = () => {
  const [theme] = useRecoilState(appThemeSelector);
  const [filters] = useRecoilState(filtersSelector);
  const [reportID] = useRecoilState(reportIDSelector);
  const [UIState, setUI] = useState(UI.Empty);
  const [URL, setURL] = useState(null);
  const generate = useRef(false);

  useAsyncEffect(async () => {
    if (filters.host_id && generate.current) {
      setUI(UI.Loading(1));

      setTimeout(async () => {
        try {
          const mainMetrics = await getMainMetrics(filters);
          setUI(UI.Loading(2));

          let uniqueVisitors = await getUniqueVisitors(filters);

          if (
            Object.keys(uniqueVisitors.perHour.national).length === 0 ||
            Object.keys(uniqueVisitors.perHour.international).length === 0
          ) {
            uniqueVisitors = await getUniqueVisitors(filters);
          }

          setUI(UI.Loading(3));
          const overnight = await getUniqueVisitorsOvernight(filters);
          setUI(UI.Loading(4));
          const ranks = await getRanks(filters);
          setUI(UI.Loading(5));

          setUI(
            UI.Success({
              mainMetrics,
              uniqueVisitors,
              overnight,
              ranks
            })
          );

          await finalizeReport(filters.token);
        } catch (error) {
          setUI(UI.Failure);
        }
      }, 3000);
    } else {
      setUI(UI.Empty);
    }
  }, [filters, generate.current]);

  return (
    <div className={`${theme.theme[theme.mode].background} flex-grow pb-40`}>
      <div className="pt-5 max-w-screen-lg mx-auto flex flex-row">
        <div className="flex w-full flex-row items-center">
          {filters.province && <Filters generate={generate} />}
        </div>
      </div>
      <div className="pt-5 max-w-screen-lg mx-auto relative">
        <Wrapper mode={theme.mode} className="relative">
          <Filters generate={generate} />
          <Map setURL={setURL} />

          {UIState.cata({
            Success: (data) => (
              <PDF generate={generate} url={URL} data={data} />
            ),
            Failure: () => <Failure reportID={reportID} />,
            Loading: (counter) => <Loading counter={counter} />,
            Empty: () => <div></div>
          })}

          <div
            className="absolute bottom-0 left-0 text-center w-full p-4 mt-10"
            style={{ fontSize: "11px", color: "rgba(0,0,0, 0.6)" }}
          >
            Los informes relativos a 2019 no incluyen los datos comparativos
            correspondientes a 2018.
          </div>
        </Wrapper>
      </div>
    </div>
  );
};

export default Panel;
